import { Pipe, PipeTransform } from '@angular/core';
import { Referrer } from '../../classes/referrer';

@Pipe({
    name: 'referrerSurnameFilter',
    pure: false
})
export class ReferrerSurnameFilterPipe implements PipeTransform {
    transform(referrerList: Array<Referrer>, filterValue: string): any {
        if (!referrerList || !filterValue) {
            return referrerList;
        }
        const normalizedFilterValue = filterValue.toLowerCase().trim();
        return referrerList.filter(referrer =>
            (referrer.Surname || '').toLowerCase().indexOf(normalizedFilterValue) !== -1
        );
    }
}
